module.exports = __webpack_public_path__ + "static/background-b0d5baa58781a9c98cfe6c17f36d7f25.jpg";